import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const Owner = () => {
  const { t } = useLang();

  return (
    <section
      id="owner"
      className="relative px-6 md:px-10 py-24 md:py-32 border-t border-white/10"
      data-testid="owner-section"
    >
      <div className="max-w-[1500px] mx-auto grid lg:grid-cols-[1fr,1fr] gap-12 lg:gap-20 items-center">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#ff00cc] mb-6">
            {t.sectionLabels.owner}
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.9]"
            data-testid="owner-name"
          >
            {t.owner.name}
          </motion.h2>
          <p className="mt-4 text-white/50 uppercase tracking-[0.3em] text-xs">
            {t.owner.label}
          </p>
          <p className="mt-8 text-white/70 leading-relaxed text-base md:text-lg max-w-xl">
            {t.owner.bio}
          </p>
          <a
            href="https://muhammadr.com"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center gap-3 pill pill-primary"
            data-testid="owner-portfolio-link"
          >
            {t.owner.cta}
            <ArrowUpRight size={18} />
          </a>
          <div className="mt-3 text-sm text-white/40">{t.owner.link}</div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative aspect-[4/5] rounded-3xl border border-white/10 overflow-hidden bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a]"
          data-testid="owner-card"
        >
          <div className="absolute inset-0 grain" />
          <div className="absolute inset-0 flex flex-col justify-between p-8 md:p-12">
            <div className="flex justify-between items-start">
              <div className="font-display text-7xl md:text-8xl text-[#ccff00] leading-none">
                MR
              </div>
              <span className="text-xs uppercase tracking-[0.3em] text-white/40 text-right">
                Owner /<br />Lead Dev
              </span>
            </div>
            <div>
              <div className="font-display text-3xl md:text-4xl leading-tight">
                Code is craft.
                <br />
                <span className="text-[#ff4500]">Quality is non-negotiable.</span>
              </div>
              <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-white/50">
                <span className="h-2 w-2 rounded-full bg-[#ccff00] animate-pulse" />
                Available for work
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Owner;
